import { IS_RTL_DIRECTION } from 'consts'

import styled, { css } from 'styled-components'

export const BackButton = styled.button<{ $gap: number }>`
  display: flex;
  gap: ${props => props.$gap}px;
  margin-top: 4px;
  margin-bottom: 12px;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  ${IS_RTL_DIRECTION &&
  css`
    justify-content: flex-end;
    flex-direction: row-reverse;
  `}
`

export const BackButtonIconWrapper = styled.div`
  margin-top: 0.5px;
`
